import { ChatMessageActionsService } from './chat-message-actions.service';

export default angular
  .module('sfMobile.services.chat-message-actions', [
    'pascalprecht.translate',
    'sfMobile.services.action-sheet',
  ])
  .service('chatMessageActionsService', ChatMessageActionsService).name;
